import { all, call, put, takeEvery } from 'redux-saga/effects'
import { t } from 'ttag'
import { addNotification } from '../../../common/notifications/NotificationActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import api from '../../../services/api.services'
import { CompanyStatistics, GetSpecificCompanyStatistics$Request } from '../../../services/api.types'
import { getSpecificCompanyStatistics, getSpecificCompanyStatisticsSuccess } from './StatisticsActions'
import { Action } from 'redux-actions'

function* sagaGetSpecificCompanyStatistics(action: Action<GetSpecificCompanyStatistics$Request>) {
  try {
    const { companyStatistics }: { companyStatistics: CompanyStatistics } = yield call(
      api.activity.getSpecificCompanyStatistics,
      action.payload,
    )
    yield put({ type: String(getSpecificCompanyStatisticsSuccess), payload: companyStatistics })
  } catch (e: any) {
    /*const getSpecificCompanyStatisticsErrorNotification: INotification = {
      type: 'warning',
      content: t`There was a problem within our system while getting company statistics. Please refresh or contact our support support@yumuuv.com`,
    }

    yield put({ type: String(addNotification), payload: getSpecificCompanyStatisticsErrorNotification })*/
  }
}

export function* statisticsSagas() {
  yield all([takeEvery(String(getSpecificCompanyStatistics), sagaGetSpecificCompanyStatistics)])
}
